<template>
  <div class="table-container">
    <vxe-grid
      border
      show-overflow
      resizable
      ref="invoiceTableRef"
      class="vxe-table-element"
      size="mini"
      align="center"
      :auto-resize="true"
      :data="tableData"
      :valid-config="{ autoPos: true, message: 'inline' }"
      :edit-rules="rule"
      :edit-config="{ trigger: 'click', mode: 'row' }"
      @edit-closed="closeEditTableHandler"
      height="300"
    >
      <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) in tableColumnList"
        :key="index"
        :field="item.field"
        :title="item.title"
        :edit-render="item.editRender"
      >
        <template v-slot="{ row }">
          <span>{{ row[item.field] }}</span>
        </template>
        <template v-slot:edit="{ row }">
          <el-select
            v-if="item.editRender.name == 'select'"
            clearable
            v-model="row[item.field]"
            :disabled="billingDisabledList.includes(item.field)"
            @change="handleChange(row, item.field)"
          >
            <el-option
              v-for="(i, index) in item.editRender.options"
              :key="index"
              :label="i.label"
              :value="i.value"
            ></el-option>
          </el-select>
          <el-input
            v-else
            v-model="row[item.field]"
            :disabled="billingDisabledList.includes(item.field)"
            @input="() => handleChange(row, item.field)"
          />
        </template>
      </vxe-table-column>
    </vxe-grid>
  </div>
</template>

<script>
  export default {
    name: 'InvoiceInfoTable',
    props: {
      billingDisabledList: {
        type: Array,
        default: () => [],
      },
      tableDataList: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableData: [],
        rule: {
          accountBank: [{ required: true, message: '请选择银行账户' }],
          accountBankNo: [{ required: true, message: '请选择银行账户' }],
          taxpayerName: [{ required: true, message: '必填字段' }],
          taxpayerIdentifyCode: [{ required: true, message: '必填字段' }],
          vatInvoiceType: [{ required: true, message: '必填字段' }],
        },
      };
    },
    computed: {
      chartRules() {
        return {
          accountBank: [{ required: true, message: '请选择银行账户' }],
          accountBankNo: [{ required: true, message: '请选择银行账户' }],
          taxpayerName: [{ required: true, message: '必填字段' }],
          taxpayerIdentifyCode: [{ required: true, message: '必填字段' }],
          vatInvoiceType: [{ required: true, message: '必填字段' }],
        };
      },
      tableColumnList() {
        return [
          {
            field: 'taxpayerName',
            title: '纳税人名称',
            editRender: {
              name: 'input',
            },
          },
          {
            field: 'taxpayerIdentifyCode',
            title: '纳税人识别号',
            editRender: {
              name: 'input',
            },
          },
          {
            field: 'accountBank',
            title: '开户银行',
            editRender: {
              name: 'input',
            },
          },
          {
            field: 'accountBankNo',
            title: '银行账号',
            editRender: {
              name: 'input',
            },
          },
          {
            field: 'addressPhone',
            title: '地址电话',
            editRender: {
              name: 'input',
            },
          },
          {
            field: 'vatInvoiceType',
            title: '增值税发票类型',
            editRender: {
              name: 'select',
              options: [
                {
                  label: '增值税专用发票',
                  value: '增值税专用发票',
                },
                {
                  label: '增值税普通发票',
                  value: '增值税普通发票',
                },
              ],
            },
          },
        ];
      },
    },
    watch: {
      tableDataList: {
        handler(val) {
          this.fullTableData(val);
        },
        immediate: true,
        deep: true,
      },
    },
    methods: {
      getTableData() {
        const $table = this.$refs.invoiceTableRef;
        return $table.getTableData().fullData;
      },
      async closeEditTableHandler() {
        const errMap = await this.$refs.invoiceTableRef.validate().catch((errMap) => errMap);
        if (errMap) {
          this.$message.error('请检查数据再提交');
        } else {
          let tableData = this.getTableData();
          await this.$refs.invoiceTableRef.clearActived();
          this.tableData = tableData;
          this.$emit('handleChange', tableData);
        }
      },
      async validate() {
        const errMap = await this.$refs.invoiceTableRef.validate().catch((errMap) => errMap);
        return errMap;
      },
      // 填充表格数据
      fullTableData(val) {
        this.tableData = val;
      },
      handleChange(row, field) {
        console.log(row, field, '行');
        this.$refs.partnerDetailRef.clearValidate();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
